/**
 * Fanatic-visibility badge (AC-VIDEO-004).
 *
 * "Visible to fans" (green check) / "Coaches only" (padlock) / "No video embed".
 * The copy comes from the server's capability catalog, so a new provider gets
 * its badge without a client change.
 */
import type { VideoProviderCapability } from '../../lib/api-types';

export function ProviderBadge({
  provider,
}: {
  provider: VideoProviderCapability;
}): JSX.Element | null {
  if (!provider.is_adapter) {
    return (
      <span className="badge badge--muted" title={provider.description}>
        {provider.description}
      </span>
    );
  }
  const isFanVisible = provider.fanatic_visible;
  return (
    <span
      className={`badge ${isFanVisible ? 'badge--fan-visible' : 'badge--coaches-only'}`}
      title={
        isFanVisible
          ? 'Fans, parents and players can watch this video.'
          : "This provider's licence limits playback to coaching staff and stat operators."
      }
    >
      <span aria-hidden="true">{isFanVisible ? '✓' : '🔒'}</span> {provider.description}
    </span>
  );
}
